<template>
  <rest-list
    :payload="fetchEndpoint"
    @dataLoaded="setData($event)"
    ref="list"
    :lazy="true"
    :lazy-handler="lazyModeHandler"
    :load="load"
    row-key="id"
  >
    <template v-if="!!(data && data.length)">
      <template>
        <rest-list-column
          prop="fields.url"
          :title="$t('CampaignChannelAnalytics_ClickedLinks_Column_Link')"
          :filter-input="false"
        />
        <rest-list-column
          prop="fields.variant"
          :filter-input="false"
          :title="$t('CampaignChannelAnalytics_ClickedLinks_Column_Variant')"
          :formatter="variantFormatter"
        />
        <rest-list-column
          prop="metricGroups[0].metrics[0].value"
          :title="$t('CampaignChannelAnalytics_ClickedLinks_Column_Total')"
          :filter-input="false"
        />
        <rest-list-column
          :filter-input="false"
          prop="metricGroups[0].metrics[1].value"
          :title="$t('CampaignChannelAnalytics_ClickedLinks_Column_Unique')"
        />
      </template>
    </template>
  </rest-list>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectEndpoint, uuid } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'ClickedLinks',
  components: { RestListColumn, RestList },
  props: {
    channel: {
      type: String,
      required: true
    },

    analyticsDateRange: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [],
      treeProps: {
        hasChildren: 'id',
        children: 'id'
      },
      expandLinkId: null
    }
  },

  methods: {
    variantFormatter(value) {
      return value || this.$t('CampaignChannelAnalytics_ClickedLinks_All')
    },
    load(tree, treeNode, resolve) {
      this.expandLinkId = tree.id
      RestApi(this.linkEndpoint).then(({ data }) => {
        data.forEach(variant => {
          variant.id = uuid()
          variant.fields.variant =
            variant.fields.variant.id + ' – ' + variant.fields.variant.title
          delete variant.fields.url
        })
        resolve(data)
      })
    },
    setData(event) {
      this.data = event
    },
    lazyModeHandler(row) {
      return !(row.fields && row.fields.variant)
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/${this.channel}/links`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    },
    linkEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `campaigns/${this.$route.query.id}/analytics/${this.channel}/links/${this.expandLinkId}`,
        params: {
          date_from: this.analyticsDateRange.date_from,
          date_to: this.analyticsDateRange.date_to
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/ClickedLinks.vue